var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-center"},[_c('div',{staticClass:"center-content container_box"},[_c('order-left'),_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }